var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13499_43242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.30884 5.83183L0 10.1271L6.26896 16.3763L10.5778 12.081L4.30884 5.83183Z",
    fill: "url(#paint0_linear_13499_43242)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3075 21.7742L19.2369 22.8412L16.629 25.4358C16.2767 25.7869 15.7094 25.7869 15.3571 25.4358L10.1504 20.2467L14.4603 15.9513L20.3029 21.7742H20.3075Z",
    fill: "#0046CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.155 15.949L21.8457 20.2438L27.6917 26.0701L32.001 21.7753L26.155 15.949Z",
    fill: "url(#paint1_linear_13499_43242)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0091 11.7648L17.6448 16.0976L11.7285 10.2239L15.4719 6.50735C15.8241 6.18538 16.3661 6.18538 16.7136 6.50735L18.5946 8.37481L20.4524 10.2193L22.0091 11.7648Z",
    fill: "#0046CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9962 10.1282L21.8436 20.2466L20.3063 21.7787L19.2357 22.8457L16.6278 25.4403C16.2755 25.7914 15.7082 25.7914 15.3559 25.4403L11.6865 21.7787L15.9964 17.4879L17.5337 15.9557L21.8436 11.6603L27.6908 5.8374L31.9962 10.1328V10.1282Z",
    fill: "#0057FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.307 10.1281L16.0017 14.4235L14.4644 15.9556L10.1545 20.251L4.30729 26.074L0.00195312 21.7786L5.84916 15.9556L10.1591 11.6602L11.6964 10.1281L15.3703 6.46654C15.3795 6.45742 15.3886 6.45286 15.3932 6.44374C15.7409 6.12455 16.2762 6.12455 16.6194 6.44374C16.6285 6.45286 16.6377 6.45742 16.6422 6.46654L18.4769 8.2996L20.3116 10.1281H20.307Z",
    fill: "#0057FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13499_43242",
    x1: 7.91245,
    y1: 13.6833,
    x2: 0.175731,
    y2: 6.04309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0046CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3AA0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13499_43242",
    x1: 24.4714,
    y1: 18.6066,
    x2: 31.6809,
    y2: 25.7352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0046CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3AA0FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13499_43242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLogo);
export default __webpack_public_path__ + "static/media/mobile-logo.57b66d9364edfc593d4338c3d191cacd.svg";
export { ForwardRef as ReactComponent };